import apiClient from '@utils/apiClient';
import {
    SeasonAddReq,
    SeasonInfo,
    SeasonInfoRes,
    SeasonListReq,
    SeasonListRes,
    SeasonPopListReq,
    SeasonPopListRes,
    SeasonUpdateReq,
} from '@/api/growth/season/type';
import { ApiResult } from '@/api/common/type';

export const api = {
    /**
     * 생육작기목록
     * @param param
     */
    seasonList: async (param: SeasonListReq): Promise<SeasonListRes> => {
        const response = await apiClient.post<SeasonListRes>(
            '/api/v1/growth/season/list',
            param,
        );
        return response.data;
    },
    /**
     * 생육작기 팝업목록
     * @param param
     */
    seasonPopList: async (
        param: SeasonPopListReq,
    ): Promise<SeasonPopListRes> => {
        const response = await apiClient.post<SeasonPopListRes>(
            '/api/v1/growth/season/pop/list',
            param,
        );
        return response.data;
    },
    seasonAdd: async (param: SeasonAddReq): Promise<ApiResult> => {
        const response = await apiClient.post<ApiResult>(
            '/api/v1/growth/season/add',
            param,
        );
        return response.data;
    },
    /**
     * 작기 정보갱신
     * @param param
     */
    seasonUpdate: async (param: SeasonUpdateReq): Promise<ApiResult> => {
        const response = await apiClient.put<ApiResult>(
            '/api/v1/growth/season/update',
            param,
        );
        return response.data;
    },
    /**
     * 작기 정보삭제
     * @param gsIdx
     */
    seasonDelete: async (gsIdx: number): Promise<ApiResult> => {
        const response = await apiClient.delete<ApiResult>(
            `/api/v1/growth/season/delete/${gsIdx}`,
        );
        return response.data;
    },
    /**
     * 작기상세
     * @param userIdx
     */
    seasonInfo: async (gsIdx: number): Promise<SeasonInfo> => {
        const response = await apiClient.get<SeasonInfoRes>(
            `/api/v1/growth/season/${gsIdx}`,
        );
        return response.data.data;
    },
};
